import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { TabHeaderItem } from '@aid/shared/types/classes/tab-header-item.class';
import { TabsService } from '@aid/shared/services';

@Component({
  selector: 'aid-tabs-header',
  template: `
    <div class="relative container">
      <mat-tab-group
        [disableRipple]="true"
        color="primary"
        class="tab-group"
        (click)="onSelect()"
      >
        @for (item of items; track item) {
          <mat-tab
            class="tab"
            aria-label="{{ item.baseRoute }}"
            label="{{ item.label | translate | sentancecase }}"
            [disabled]="item.disabled"
          ></mat-tab>
        }
      </mat-tab-group>

      <div class="right">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./tabs-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TabsHeaderComponent implements OnInit, AfterViewInit {
  @Input() items?: TabHeaderItem[];

  @Input('route') set _route(route: string[] | null | undefined) {
    this.route = route;
    if (!this.tabGroup || !this.tabGroup._tabs || !route) {
      return;
    }
    this.navigateToTab();
  }
  @Output() navigateTo: EventEmitter<string> = new EventEmitter();

  route?: string[] | null;
  @ViewChild(MatTabGroup, { static: true }) tabGroup?: MatTabGroup;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.navigateToTab();
  }
  routesMatch(tabRoute: string[]) {
    const route = this.route;
    if (!route) {
      return false;
    }
    for (let i = 0; i < tabRoute.length; i++) {
      if (tabRoute[i] !== route[i]) {
        return false;
      }
    }

    return true;
  }

  onSelect() {
    const tabGroup = this.renderedTabGroup;
    if (tabGroup.selectedIndex === null) {
      return;
    }
    this.navigateTo.emit(
      tabGroup._tabs.toArray()[tabGroup.selectedIndex].ariaLabel
    );
  }
  private navigateToTab() {
    const tabGroup = this.renderedTabGroup;
    tabGroup._tabs.forEach((item: MatTab, index: number) => {
      const tabRoute: string[] = item.ariaLabel.split('/');
      if (this.routesMatch(tabRoute)) {
        tabGroup.selectedIndex = index;
      }
    });
  }

  private get renderedTabGroup(): MatTabGroup {
    if (!this.tabGroup) {
      throw new Error('aid-tabs-header: the tab group is not rendered.');
    }
    return this.tabGroup;
  }
}
